import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{attrs:{"id":"gm"}},[_c('GmHeader'),_c(VNavigationDrawer,{attrs:{"width":"355","disable-resize-watcher":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('Sidebar')],1),_c(VMain,[_c('router-view')],1),_c('GmFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }